module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Street":"Straße","Zipcode":"PLZ","City":"Stadt","Country":"Land","Select a country":"Land auswählen","Company":"Firma","VAT ID":"USt-IdNr.","e.g. DE123456789":"z.B. DE123456789","Gender":"Anrede","First name":"Vorname","Last name":"Nachname","Select":"Auswählen","Mr.":"Herr","Mrs.":"Frau","Diverse":"Divers","Email":"E-Mail","Phone":"Telefon"}}')
  delete Component.options._Ctor
}
